import { useStrictLocalization } from "@faire/web--source/common/localization";

export const useLoggedOutBrandNodes = () => {
  const { strictLocalize } = useStrictLocalization();
  const loggedOutBrandNodes = {
    L1: {
      Account: strictLocalize({
        defaultMessage: "Account settings (e.g. update email, bank info)",
        description: { text: "Type of issue for a help center ticket" },
      }),
      Catalog: strictLocalize({
        defaultMessage: "Catalog and shop information",
        description: { text: "Type of issue for a help center ticket" },
      }),
      Disputes: strictLocalize({
        defaultMessage: "Disputes",
        description: { text: "Type of issue for a help center ticket" },
      }),
      Invoices: strictLocalize({
        defaultMessage: "Invoices and payments",
        description: { text: "Type of issue for a help center ticket" },
      }),
      Orders: strictLocalize({
        defaultMessage: "Orders and fulfillment",
        description: { text: "Type of issue for a help center ticket" },
      }),
      UpdateCommission: strictLocalize({
        defaultMessage: "Update commission / relationship",
        description: { text: "Type of issue for a help center ticket" },
      }),
      GeneralShipping: strictLocalize({
        defaultMessage: "General shipping questions",
        description: {
          text: "Type of issue for a help center article",
        },
      }),
      Other: strictLocalize({
        defaultMessage: "Other Brand Issues",
        description: { text: "Type of issue for a help center ticket" },
      }),
    },
    L2: {
      SWF: strictLocalize({
        defaultMessage: "Ship with Faire",
        description: {
          text: "Type of issue for a help center article",
        },
      }),
      SOYO: strictLocalize({
        defaultMessage: "Ship on your own",
        description: {
          text: "Type of issue for a help center article",
        },
      }),
      SellingInternational: strictLocalize({
        defaultMessage: "Selling International",
        description: {
          text: "Type of issue for a help center article",
        },
      }),
      Other: strictLocalize({
        defaultMessage: "Other questions",
        description: {
          text: "Type of issue for a help center article",
        },
      }),
    },
    L3: {
      Availability: strictLocalize({
        defaultMessage: "Is ship with Faire available in my country?",
        description: {
          text: "Type of issue for a help center article, explain when ship with Faire is available",
        },
      }),
      LabelIssues: strictLocalize({
        defaultMessage: "Label issues",
        description: {
          text: "Type of issue for a help center article, explain shipping label issue",
        },
      }),
      Costs: strictLocalize({
        defaultMessage: "Costs",
        description: {
          text: "Type of issue for a help center article, explain ship on your own costs related issues",
        },
      }),
      Others: strictLocalize({
        defaultMessage: "Others",
        description: {
          text: "Type of issue for a help center article",
        },
      }),
      HowTo: strictLocalize({
        defaultMessage: "How to?",
        description: {
          text: "Type of issue for a help center article, explain how to ship orders on your own",
        },
      }),
    },
  };
  return loggedOutBrandNodes;
};
